import {
    getPrimaryMailboxSearchScopeKey,
    getArchiveMailboxSearchScopeKey,
    getSharedFoldersSearchScopeKey,
    getSingleGroupSearchScopeKey,
    getCalendarSearchScopeKey,
} from './getSearchScopeKey';
import {
    getPrimaryMailboxSearchScopeType,
    getArchiveMailboxSearchScopeType,
    getSharedFoldersSearchScopeType,
    getSingleGroupSearchScopeType,
    getCalendarSearchScopeType,
} from './getSearchScopeType';
import { SearchScope, SearchScopeKind } from '../../data/schema/SearchScope';
import BaseSearchScopeType from 'owa-service/lib/contract/BaseSearchScopeType';
import {
    getPrimaryMailboxSearchScopeList,
    getArchiveMailboxSearchScopeList,
    getSharedFoldersScopeList,
    getGroupSearchScopeList,
    getCalendarSearchScopeList,
} from './getSearchScopeList';

interface SearchScenario {
    // Gets the Unique Key related a given SearchScope
    getKey: (scope: SearchScope) => string;

    // Gets the SearchScope list used for the current scope scenario
    getSearchScopeList: () => SearchScope[];

    // Gets the BaseSearchScopeType object used for the search request for a given SearchScope
    getSearchScopeType: (scope: SearchScope) => BaseSearchScopeType[];
}

let primaryMailboxScenario: SearchScenario = {
    getKey: getPrimaryMailboxSearchScopeKey,
    getSearchScopeList: getPrimaryMailboxSearchScopeList,
    getSearchScopeType: getPrimaryMailboxSearchScopeType,
};

let archiveMailboxScenario: SearchScenario = {
    getKey: getArchiveMailboxSearchScopeKey,
    getSearchScopeList: getArchiveMailboxSearchScopeList,
    getSearchScopeType: getArchiveMailboxSearchScopeType,
};

let sharedFoldersScenario: SearchScenario = {
    getKey: getSharedFoldersSearchScopeKey,
    getSearchScopeList: getSharedFoldersScopeList,
    getSearchScopeType: getSharedFoldersSearchScopeType,
};

let groupScenario: SearchScenario = {
    getKey: getSingleGroupSearchScopeKey,
    getSearchScopeList: getGroupSearchScopeList,
    getSearchScopeType: getSingleGroupSearchScopeType,
};

let calendarScenario: SearchScenario = {
    getKey: getCalendarSearchScopeKey,
    getSearchScopeList: getCalendarSearchScopeList,
    getSearchScopeType: getCalendarSearchScopeType,
};

let pickScenario = (scope: SearchScope) => {
    switch (scope.kind) {
        case SearchScopeKind.PrimaryMailbox:
            return primaryMailboxScenario;
        case SearchScopeKind.ArchiveMailbox:
            return archiveMailboxScenario;
        case SearchScopeKind.SharedFolders:
            return sharedFoldersScenario;
        case SearchScopeKind.Group:
            return groupScenario;
        case SearchScopeKind.Calendar:
            return calendarScenario;
        default:
            throw new Error('Unregistered search scope');
    }
};

export let getKey = (scope: SearchScope) => pickScenario(scope).getKey(scope);
export let getSearchScopeList = (scope: SearchScope) => pickScenario(scope).getSearchScopeList();
export let getSearchScopeType = (scope: SearchScope) =>
    pickScenario(scope).getSearchScopeType(scope);
